import blob1 from "@/assets/imgs/blob 1.png";
import blob2 from "@/assets/imgs/blob (1) 1.png";
import blob3 from "@/assets/imgs/blob (2) 1.png";

const WhyParentsLoveBooq = () => {
  return (
    <section className="container m-auto why-parents-love-booq">
      <h2>Why Parents Trust Booq</h2>
      <div className="why-parents-love-booq-grid">
        <img src={blob1} />
        <img src={blob2} />
        <img src={blob3} />
      </div>
    </section>
  );
};

export default WhyParentsLoveBooq;
